var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngiScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb9bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36719,
    stopColor: "#ff776e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#ff6153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db5863"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.52289,71.89618c.84802,0,1.69836-.13629,2.51862-.41821,3.90509-1.34485,5.20142-4.6214,5.80914-7.62073,0,.00464-.00232.00928-.00232.0116.33502-1.43036,1.11145-6.92059,1.25006-8.54034,3.99292.94043,6.41681,5.18054,7.01532,9.76959l.3512,2.57184h6.64789l-6.34747-39.5661h-9.5871l-3.27655,20.44043c-.07166.00928-.14099.01385-.21033.02313-7.24402.96356-12.86829,7.05914-12.80359,13.88037.02777,2.85138,1.00287,5.07892,2.74512,6.90436,1.57361,1.64984,3.72253,2.54407,5.89001,2.54407ZM52.85278,34.35889h.23566l2.12817,16.32507c-1.35175-.73944-2.789-1.31476-4.2702-1.69604l1.90637-14.62903ZM43.82257,55.25916l-1.0791,6.81427c-.3443,1.93402-.79724,3.08942-1.76306,3.42212-.57538.19873-1.28937-.0069-1.77002-.51068-.61926-.65161-.98206-1.37482-.99359-2.59491-.03235-3.40826,2.64575-6.08173,5.60577-7.1308Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngiScraper);
export default __webpack_public_path__ + "static/media/angi-scraper.c1b02a84ecf5973332a4ac16ffc4d36f.svg";
export { ForwardRef as ReactComponent };